const insertJs = async function () {
  if (window.TencentCaptcha) {
    return Promise.resolve();
  }

  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js';

  document.body.appendChild(script);

  return new Promise((resolve) => {
    script.onload = resolve;
  });
};

export const txCaptcha = async function ({ appid }) {
  await insertJs();

  return new Promise((resolve, reject) => {
    try {
      // eslint-disable-next-line no-undef
      const captcha = new TencentCaptcha(
        appid,
        (res) => {
          if (res.ret === 0) {
            resolve(res);
          } else {
            reject(res);
          }
          captcha.destroy();
        },
        {
          needFeedBack: false,
          userLanguage: 'zh-cn'
        }
      );
      captcha.show();
    } catch (e) {
      reject({
        ret: 1
      });
    }
  });
};
